// chat-button.js - Handle chat panel functionality

import { showConfirmation } from './modal.js';

export class ChatManager {
  constructor() {
    this.chatButton = document.getElementById('btn-open-chat');
    
    if (!this.chatButton) {
      console.warn('Chat button not found in the DOM');
      return;
    }
    
    // Initialize chat panel elements
    this.chatPanel = document.getElementById('chat-interface');
    this.chatPanelCloseButton = document.getElementById('btn-chat-close');
    // GEÄNDERT: Fullscreen-Button Referenz entfernen
    this.chatPanelSplitscreenButton = document.getElementById('btn-chat-splitscreen');
    this.chatResetButton = document.getElementById('btn-chat-reset');

    // Bind event listeners
    this.chatButton.addEventListener('click', this.togglePanel.bind(this));
    
    // Add panel control listeners
    if (this.chatPanelCloseButton) {
      this.chatPanelCloseButton.addEventListener('click', () => this.hideChatPanel());
    }
    
    if (this.chatPanelSplitscreenButton) {
      this.chatPanelSplitscreenButton.addEventListener('click', () => this.showChatPanel());
    }

    if (this.chatResetButton) {
      this.chatResetButton.addEventListener('click', () => this.resetChat());
    }
  }

  /**
   * Toggle the chat panel visibility
   */
  togglePanel() {
    // Check if we need to show or hide the chat panel
    const chatPanel = document.getElementById('chat-interface');
    
    if (!chatPanel || chatPanel.style.display === 'none' || !chatPanel.offsetWidth) {
      // Show the chat panel
      this.showChatPanel();
    } else {
      // Hide the chat panel
      this.hideChatPanel();
    }
  }

  /**
   * Show the chat panel in split mode with editor
   */
  showChatPanel() {
    // Get elements
    const editorPanel = document.getElementById('markdown-editor');
    const chatPanel = document.getElementById('chat-interface');
    
    if (chatPanel) {
      // Show chat panel in split mode
      chatPanel.classList.add('visible', 'split-mode');
      chatPanel.classList.remove('full-mode');
      chatPanel.style.display = 'flex';
      
      if (this.chatPanelSplitscreenButton) this.chatPanelSplitscreenButton.style.display = 'none';
      
      // Shrink editor panel for side-by-side view
      if (editorPanel) {
        editorPanel.classList.add('split-with-chat');
        editorPanel.style.flex = '1 1 50%';
        editorPanel.style.display = 'flex';
      }
      
      // WICHTIG: Chat-Button immer ausblenden, unabhängig vom this-Kontext
      const chatButton = document.getElementById('btn-open-chat');
      if (chatButton) {
        chatButton.style.display = 'none';
      }
    }
  }

  /**
   * Hide the chat panel
   */
  hideChatPanel() {
    const chatPanel = document.getElementById('chat-interface');
    const editorPanel = document.getElementById('markdown-editor');
    
    if (chatPanel) {
      // Hide chat panel
      chatPanel.style.display = 'none';
      chatPanel.classList.remove('visible', 'full-mode', 'split-mode');
      
      // Restore editor panel to full size
      if (editorPanel) {
        editorPanel.classList.remove('split-with-chat');
        editorPanel.style.flex = '1';
        editorPanel.style.width = '100%';
        editorPanel.style.display = 'flex';
      }
      
      // WICHTIG: Beide Buttons wieder anzeigen, wenn Chat Panel geschlossen wird
      // Chat-Button wieder anzeigen
      const chatButton = document.getElementById('btn-open-chat');
      if (chatButton) {
        chatButton.style.display = 'flex';
      }
    }
  }

  /**
   * Reset the chat conversation
   */
  async resetChat() {
    const chatMessages = document.getElementById('chat-messages');
    if (chatMessages) {
      chatMessages.innerHTML = '';
    }
    window.buddyVerlaufLeeren?.();

    // Send reset request to backend to clear server-side conversation state
    try {
      const response = await fetch('/api/chat/reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        console.warn('Failed to reset chat on server:', response.statusText);
      }
    } catch (error) {
      console.error('Error resetting chat:', error);
    }
  }

  /**
   * Switch to fullscreen chat panel
   */
  showFullscreenChat() {
    // Get elements
    const editorPanel = document.getElementById('markdown-editor');
    const chatPanel = document.getElementById('chat-interface');
    
    if (chatPanel) {
      // Show chat panel in full mode
      chatPanel.classList.add('visible', 'full-mode');
      chatPanel.classList.remove('split-mode');
      
      // WICHTIG: Explizit display auf flex setzen, damit das Panel sichtbar wird
      chatPanel.style.display = 'flex';
      
      // Style the chat panel for full mode
      chatPanel.style.flex = '1 1 100%';
      chatPanel.style.width = '100%';
      chatPanel.style.maxWidth = '100%';
      
      // Hide editor panel
      if (editorPanel) {
        editorPanel.style.display = 'none';
        editorPanel.classList.remove('split-with-chat');
      }
      
      // Configure buttons
      if (this.chatPanelSplitscreenButton) this.chatPanelSplitscreenButton.style.display = 'flex';
      if (this.chatButton) this.chatButton.style.display = 'none';
    }
  }

  /**
   * Initialize UI after DOM is fully loaded
   */
  init() {
    // Make sure chat panel is properly initialized at startup
    const chatPanel = document.getElementById('chat-interface');
    if (chatPanel) {
      // Apply any necessary initial class, but keep it initially hidden
      chatPanel.classList.add('chat-panel');
    }
  }
}

export default ChatManager;